import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=3028f90b&scoped=true&"
import script from "./UpdateProfile.vue?vue&type=script&lang=js&"
export * from "./UpdateProfile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProfile.vue?vue&type=style&index=0&id=3028f90b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028f90b",
  null
  
)

export default component.exports